export default {
    getTotalOrderCount: state => {
      console.log('in getTotalOrderCount state.totalOrderCount = ' + state.totalOrderCount)
      console.log('in getTotalOrderCount state.ordersList = ' + state.ordersList)
      return state.totalOrderCount;
    },
    getOrdersList: state => {
        return state.ordersList;
    },
    getDetailsList: state => {
        return state.detailsList;
    },
    getDetailsListCount: state => {
        return state.detailsListCount;
    },
    getContactsList: state => {
        return state.contactsList;
    },
    getShareableContactsList: state => {
        return state.shareableContactsList;
    },
    getSharedContactsList: state => {
        return state.sharedContactsList;
    },
    getEscSearchIcon: state => {
        return state.escSearchIcon;
    },
    getToolsClassifyList: state => {
        return state.toolsClassifyList;
    }
};



// WEBPACK FOOTER //
// ./src/store/config/getters.js